// extracted by mini-css-extract-plugin
module.exports = {"filterIcon":"mobile-filter-modal_filterIcon__5af5R","filterBadge":"mobile-filter-modal_filterBadge___1foy"};